module.exports = __webpack_public_path__ + "media/images/landing/studies/sq3-b88f1bfb0610b8e24528101b0e1bd1f1.jpg";